module.exports = __webpack_public_path__ + "static/media/merlinIcons.c160fe24.woff";